import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import { REGISTRATION_URL, SITE, LEGAL, LOGO_WHITE_URL, FEDERATION_LOGO_URL } from "@/lib/config";
import { openCookiePreferences } from "@/components/legal/cookieConsent";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="bg-[#082050] text-white mt-24 pb-20 md:pb-0"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
                <div className="md:col-span-5">
                    <div className="mb-6">
                        <img
                            src={LOGO_WHITE_URL}
                            alt={`Logo oficial de ${SITE.fullName}`}
                            className="h-14 sm:h-16 w-auto"
                            width="240"
                            height="59"
                            loading="lazy"
                        />
                    </div>
                    <p className="text-sm text-white/70 max-w-md leading-relaxed">
                        {SITE.fullName}. Representamos al sector del alojamiento en
                        Tarifa: hoteles, campings, hostales y apartamentos.
                    </p>
                    <p className="mt-3 text-xs text-white/50">
                        CIF: {LEGAL.cif}
                    </p>
                    <a
                        href={REGISTRATION_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="btn-hazte-socio-footer"
                        className="inline-block mt-6 bg-white text-[#082050] px-6 py-3 text-sm font-medium hover:bg-white/90"
                    >
                        Hazte socio · {SITE.quota}
                    </a>
                </div>

                <div className="md:col-span-3">
                    <h4 className="text-sm font-semibold text-white mb-4 tracking-tight">
                        Navegación
                    </h4>
                    <ul className="space-y-2 text-sm text-white/70">
                        <li><Link to="/" className="hover:text-white">Inicio</Link></li>
                        <li><Link to="/institucional" className="hover:text-white">Institucional</Link></li>
                        <li><Link to="/noticias" className="hover:text-white">Noticias</Link></li>
                        <li><Link to="/eventos" className="hover:text-white">Eventos</Link></li>
                        <li><Link to="/directorio" className="hover:text-white">Directorio</Link></li>
                        <li><Link to="/area-socios" className="hover:text-white">Área de socios</Link></li>
                        <li><Link to="/contacto" className="hover:text-white">Contacto</Link></li>
                    </ul>
                </div>

                <div className="md:col-span-2">
                    <h4 className="text-sm font-semibold text-white mb-4 tracking-tight">
                        Legal
                    </h4>
                    <ul className="space-y-2 text-sm text-white/70">
                        <li>
                            <Link
                                to="/aviso-legal"
                                data-testid="footer-aviso-legal"
                                className="hover:text-white"
                            >
                                Aviso Legal
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/politica-de-privacidad"
                                data-testid="footer-privacidad"
                                className="hover:text-white"
                            >
                                Política de Privacidad
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/politica-de-cookies"
                                data-testid="footer-cookies"
                                className="hover:text-white"
                            >
                                Política de Cookies
                            </Link>
                        </li>
                        <li>
                            <button
                                type="button"
                                onClick={openCookiePreferences}
                                data-testid="footer-config-cookies"
                                className="hover:text-white text-left"
                            >
                                Configuración de Cookies
                            </button>
                        </li>
                    </ul>
                </div>

                <div className="md:col-span-2">
                    <h4 className="text-sm font-semibold text-white mb-4 tracking-tight">
                        Contacto
                    </h4>
                    <ul className="space-y-3 text-sm text-white/70">
                        <li className="flex items-start gap-2">
                            <MapPin size={14} className="mt-1 shrink-0" />
                            <span>{SITE.address}</span>
                        </li>
                        <li className="flex items-center gap-2">
                            <Mail size={14} />
                            <a href={`mailto:${SITE.email}`} className="hover:text-white break-all">
                                {SITE.email}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div
                data-testid="federation-band"
                className="border-t border-white/10"
            >
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center gap-4 sm:gap-6">
                    <div className="bg-white px-4 py-3 flex items-center justify-center shrink-0">
                        <img
                            src={FEDERATION_LOGO_URL}
                            alt="Logo de la Federación de Asociaciones de Empresarios de Tarifa"
                            className="h-10 sm:h-12 w-auto"
                            width="180"
                            height="48"
                            loading="lazy"
                        />
                    </div>
                    <p className="text-xs sm:text-sm text-white/70 text-center sm:text-left leading-snug">
                        Miembro de la Federación de Asociaciones de Empresarios de Tarifa
                    </p>
                </div>
            </div>
            <div className="border-t border-white/10">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
                    <p className="text-xs text-white/50">
                        © {new Date().getFullYear()} {SITE.fullName}. Todos los derechos reservados.
                    </p>
                </div>
            </div>
        </footer>
    );
}
